// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vaAQ","footer":"styles_footer__3LAKc","passCodeTooltip":"styles_passCodeTooltip__2N-w4"};